import { render, staticRenderFns } from "./ModalChargeContacs.vue?vue&type=template&id=05bf8d91&scoped=true&"
import script from "./ModalChargeContacs.vue?vue&type=script&lang=js&"
export * from "./ModalChargeContacs.vue?vue&type=script&lang=js&"
import style0 from "./ModalChargeContacs.vue?vue&type=style&index=0&id=05bf8d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf8d91",
  null
  
)

export default component.exports